/**
 * Locations actions.
 * @module actions/locations
 */
export const GET_LOCATIONS = 'GET_LOCATIONS';

/**
 * Get locations.
 * @function getLocations
 * @returns {Object} Get locations action.
 */
export function getLocations(path) {
  return {
    type: GET_LOCATIONS,
    request: {
      op: 'get',
      path: `${path}/@locations`,
    },
  };
}
